import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class PushLogStore extends LocalModel {
    constructor() {
        super('pushLog', {
            namePlural: 'pushLogList',
            namePluralReal: 'pushlogs',
            sort: '-createdDate',
            limit: 200,
            api: {
                search: {
                    url: '/api/pushlogs/',
                    params: {
                        limit: 50,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/pushlogs/',
                    params: {},
                },
                save: {
                    url: '/api/pushlogs/',
                    params: {},
                },
                delete: {
                    url: '/api/pushlogs/',
                    params: {},
                },
            },
        });
    }

    @observable pushLog = {};

    @observable pushLogList = [];
}

const store = new PushLogStore();
export default store;
